import { render, staticRenderFns } from "./MessageError.vue?vue&type=template&id=831851f4&"
import script from "./MessageError.vue?vue&type=script&lang=js&"
export * from "./MessageError.vue?vue&type=script&lang=js&"
import style0 from "./MessageError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports